/**
 * Typography tokens from Figma design system
 *
 * MUI Mapping:
 * - fontFamily → theme.typography.fontFamily
 * - fontWeight → theme.typography.[variant].fontWeight
 * - fontSize → theme.typography.[variant].fontSize
 * - lineHeight → theme.typography.[variant].lineHeight
 */

export const typographyColor = {
  color: '#333333',
} as const;

export const fontFamily = {
  family: 'Roboto',
} as const;

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700,
} as const;

export const fontSize = {
  h1: 96,
  h2: 60,
  h3: 48,
  h4: 34,
  h5: 24,
  h6: 20,
  subtitle1: 16,
  subtitle2: 14,
  body1: 16,
  body2: 14,
  caption: 12,
  overline: 12,
} as const;

export const lineHeight = {
  h1: 116.7,
  h2: 120,
  h3: 116.7,
  h4: 123.5,
  h5: 133.4,
  h6: 160,
  subtitle1: 150,
  subtitle2: 143,
  body1: 175,
  body2: 157,
  caption: 266,
  overline: 166,
} as const;

export type TypographyColor = typeof typographyColor;
export type FontFamily = typeof fontFamily;
export type FontWeight = typeof fontWeight;
export type FontSize = typeof fontSize;
export type LineHeight = typeof lineHeight;
